import styled, { css } from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";
import logo from "../img/brand.png";
// import premiumLogo from "../img/premiumBrandPink.png";
import mobileLogo from "../img/mobileBrand.png";
// import premiumMobileLogo from "../img/premiumMobileBrandPink.png";
// import portalLogo from "../../../shared/general/img/hhPortalLogo.png";
// import partnerNetworkLogo from "../img/partnerNetworkBrand.png";

export const BrandWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
`;

export const PremiumBrand = styled.div`
  height: 40px;
  width: 180px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${mediaMaxWidth.tablet`
    background-image: url(${mobileLogo});
     width: 80px;
    height: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    background-image: url(${mobileLogo});
    width: 75px;
    height: 40px;
  `}
`;

export const Brand = styled.div`
  height: 40px;
  width: 180px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${mediaMaxWidth.tablet`
    background-image: url(${mobileLogo});
     width: 80px;
    height: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    background-image: url(${mobileLogo});
    width: 75px;
    height: 40px;
  `}
`;

export const PortalBrand = styled.div`
  height: 40px;
  width: 180px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${mediaMaxWidth.tablet`
    background-image: url(${mobileLogo});
     width: 80px;
    height: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    background-image: url(${mobileLogo});
    width: 75px;
    height: 40px;
  `}
`;

export const PartnerNetworkBrand = styled.div`
  height: 40px;
  width: 180px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${mediaMaxWidth.tablet`
    background-image: url(${mobileLogo});
     width: 80px;
    height: 40px;
  `}

  ${mediaMaxWidth.smallPhone`
    background-image: url(${mobileLogo});
    width: 75px;
    height: 40px;
  `}
`;
